import { MutationFunction } from '@tanstack/react-query';
import { InternalAxiosRequestConfig } from 'axios';
import Cookies from 'js-cookie';

import config from 'config';
import {
  ACCESS_TOKEN_KEY_CADASTRAL_CHANGE,
  ACCESS_TOKEN_EXPIRES_IN_CADASTRAL_CHANGE,
  setAccessToken,
} from 'services/auth';

import { apiGRecaptcha as api } from '../api-grecaptcha';

import type { AuthCredentials, AuthPayload } from 'domains/auth';

export const postUserLogin: MutationFunction<AuthPayload, AuthCredentials> = async (
  data: AuthCredentials
) => {
  api.interceptors.request.use(embbedRecaptchaKeys);

  return (await api.post(`/auth`, data).then((resp) => {
    setAccessToken({
      accessTokenkey: ACCESS_TOKEN_KEY_CADASTRAL_CHANGE,
      token: resp.data?.access_token,
      expiresIn: ACCESS_TOKEN_EXPIRES_IN_CADASTRAL_CHANGE,
    });
  })) as AuthPayload;
};

export function embbedRecaptchaKeys(request: InternalAxiosRequestConfig) {
  const {
    google: { recaptcha },
  } = config;

  request.headers['x-rc-authorization'] = Cookies.get('X-Recaptcha-Token');
  request.headers['x-rc-sitekey'] = recaptcha.siteKey;
  return request;
}
